import React, { useState } from 'react';
import { TextField, Button, Select, MenuItem, Snackbar } from '@mui/material';
import axios from 'axios';

const BulkUpdateComponent = () => {
  const [type, setType] = useState('institution');
  const [bulkText, setBulkText] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleBulkUpdate = async () => {
    try {
      const updates = bulkText.split('\n').map(line => {
        const [oldName, newName] = line.split(',').map(item => item.trim());
        return { oldName, newName };
      });

      await axios.post('/api/bulk-update', { type, updates });
      setSnackbarMessage('Items updated successfully');
    } catch (error) {
      setSnackbarMessage('Error updating items: ' + (error.response?.data?.message || error.message));
    } finally {
      setSnackbarOpen(true);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <Select
        value={type}
        onChange={(event) => setType(event.target.value)}
        displayEmpty
        style={{ width: 200 }}
      >
        <MenuItem value="institution">Institution</MenuItem>
        <MenuItem value="organization">Organization</MenuItem>
        <MenuItem value="skill">Skill</MenuItem>
      </Select>
      <TextField
        multiline
        rows={10}
        value={bulkText}
        onChange={(e) => setBulkText(e.target.value)}
        placeholder="Enter items in the format: oldName, newName"
        variant="outlined"
        fullWidth
        style={{ marginTop: 20 }}
      />
      <Button variant="contained" color="primary" onClick={handleBulkUpdate} style={{ marginTop: 20 }}>
        Update
      </Button>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
      />
    </div>
  );
};

export default BulkUpdateComponent;
